/* eslint-disable eqeqeq */
import React, { Fragment } from "react";
import BlockUi from "react-block-ui";
import { Loader } from "react-loaders";
import { Bounce, toast } from "react-toastify";
import { Button, Col, Form, Row } from "reactstrap";
import bg4 from "../assets/architect/utils/images/originals/bg_white.jpg";
import picLogo from "../assets/architect/utils/images/originals/pic_logo.png";
import CostumForm from "../common/Form/form";
import * as UsersService from "../services/users/api_user";



class ChangePassword extends CostumForm {
  constructor(props) {
    super(props);

    let tk = "";
    if (
      props &&
      props.match &&
      props.match.params &&
      props.match.params.token
    ) {
      tk = props.match.params.token;
    }

    this.state = {
      blocking: false,
      token: tk,
      credentials: {
        email: "",
        password: "",
        repeatPassword: "",
      },
      errors: {},
    };
  }

  /*********************************** LIFECYCLE ***********************************/
  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  /*********************************** HANDLERS ***********************************/

  validateEmail(email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
  }

  resetPassword = () => {
    const { credentials, token } = this.state;

    if (credentials.email.length == 0) {
      const errorMessage = "No email inserted.";

      toast(errorMessage, {
        transition: Bounce,
        closeButton: true,
        autoClose: 2000,
        position: "top-right",
        type: "error",
      });
    } else {
      const payload = {
        credentials: credentials,
        token: token,
      };
      UsersService.resetPasswordWithToken(payload, function(result) {
        if (result && result.data && result.data.error) {
          toast(result.data.error, {
            transition: Bounce,
            closeButton: true,
            autoClose: 2000,
            position: "top-right",
            type: "error",
          });
        } else {
          //Success
          toast("Success changing password", {
            transition: Bounce,
            closeButton: true,
            autoClose: 2000,
            position: "top-right",
            type: "success",
          });
          window.location = "/";
        }
      });
    }
  };

  render() {
    const { credentials } = this.state;
    return (
      <Fragment>
        <BlockUi
          tag="div"
          blocking={this.state.blocking}
          loader={<Loader active type="line-scale-pulse-out" />}
        >
          <div className="h-100 bg-animation">
            <div
              className="d-flex h-100 justify-content-center align-items-center"
              style={{
                background: "url(" + bg4 + ")",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center center",
              }}
            >
              <Col md="8" className="mx-auto app-login-box">
                <div
                  className="modal-dialog w-100 mx-auto"
                  style={{
                    boxShadow: "0px 1px 10px 0px rgba(52, 58, 64, 0.3)",
                  }}
                >
                  <div className="modal-content" style={{ border: "none" }}>
                    <div className="modal-body" style={{ padding: "2.5rem" }}>
                      <div className="h6 modal-title text-center mb-4">
                        <img
                          alt="Company logo"
                          className="mb-4"
                          src={picLogo}
                          style={{ height: "100px", width: "auto" }}
                        />
                        <p>PICAdvanced Client Management Platform</p>
                      </div>
                      <Form>
                        <Row>
                          <Col md={12}>
                            {this.renderInput(
                              "email",
                              "email",
                              "Email",
                              "Enter email"
                            )}
                          </Col>
                          <Col md={6}>
                            {this.renderInput(
                              "password",
                              "password",
                              "Password"
                            )}
                          </Col>
                          <Col md={6}>
                            {this.renderInput(
                              "repeatPassword",
                              "password",
                              "Repeat Password",
                              "Repeat Password here..."
                            )}
                          </Col>

                          <Col md={12} style={{ textAlign: "center" }}>
                            <Button
                              style={{
                                marginTop: "5px",
                                background: "#34b4eb",
                                color: "#fff",
                                width: "200px",
                                textAlign: "center",
                              }}
                              disabled={
                                credentials.password.length < 3 ||
                                !this.validateEmail(credentials.email) ||
                                credentials.password !=
                                  credentials.repeatPassword
                              }
                              onClick={this.resetPassword}
                            >
                              Save my new Password
                            </Button>
                          </Col>
                        </Row>
                      </Form>
                    </div>
                  </div>
                </div>
                <div className="text-center text-black opacity-8 mt-3">
                  Copyright &copy; PICAdvanced {new Date().getFullYear()}
                </div>
              </Col>
            </div>
          </div>
        </BlockUi>
      </Fragment>
    );
  }
}

export default ChangePassword;



// WEBPACK FOOTER //
// ./src/User/ChangePasswordPage.js